import { get_cookie } from './cookies';

const app_info = new class {
	constructor() {
		this.push_info = null;
		var txt = get_cookie("push_info");
		if (txt) {
			try {
				this.push_info = JSON.parse(txt);
			} catch (e) {
			}
		}
	}

	is_app() {
		return !!this.push_info;
	}
}();

const is_app = app_info.is_app();

export {
	is_app
};



// WEBPACK FOOTER //
// ./src/App.js